import { ROOT_STATUS } from "."

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_CREATED : {
    key: 'STATUS_CREATED',
    value: 'Created',
    color: 'secondary',
    icon: '',
  },
  STATUS_ONGOING : {
    key: 'STATUS_ONGOING',
    value: 'Ongoing',
    color: 'primary',
    icon: '',
  },
  STATUS_PROCESSING : {
    key: 'STATUS_PROCESSING',
    value: 'Processing',
    color: 'secondary',
    icon: '',
  },
  STATUS_COMPLETED : {
    key: 'STATUS_COMPLETED',
    value: 'Completed',
    color: 'success',
    icon: '',
  },
  STATUS_CANCEL : {
    key: 'STATUS_CANCEL',
    value: 'Cancel',
    color: 'error',
    icon: '',
  },
}